import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleDataType, SimpleResponse } from '../models/genericResponse.model';
import { APIMessage } from '../models/signupMsg.model';
import { EmailPrefConfirm, IHEmailUnsubscribe, IHReferralRequest, Msg, EngageEmailUnsubscribe, EngageUnSubsSaveRequest, EngageUpdateSaveRequest, TempContact, TempContactResponse, EngageUnSubSetupResponse } from '../models/engage-post.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class EngagePostService {
    private baseUrl: string;
    private api: string = "api/EngagePost";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async decryptString(encryptedUser: string, request: SimpleDataType): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/DecryptString`, request, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, "EngagePostService", "decryptString"); });
        return a;
    }
    async urlEncodeEncryptString(encryptedUser: string, request: SimpleDataType): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/UrlEncodeEncryptString`, request, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, "EngagePostService", "UrlEncodeEncryptString"); });
        return a;
    }

    async iHUnSubscribe(encryptedUser: string, iHEmailUnsubscribeRequest: IHEmailUnsubscribe): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/IHUnSubscribe`, iHEmailUnsubscribeRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, iHEmailUnsubscribeRequest, "r - " + encryptedUser, "EngagePostService", "iHUnSubscribe"); });
        return a;
    }

    async msgUpdate(encryptedUser: string, msg: Msg): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/Msg_Update`, msg, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, msg, "r - " + encryptedUser, "EngagePostService", "msgUpdate"); });
        return a;
    }

    async sendThankYouEmail(encryptedUser: string, iHReferralRequest: IHReferralRequest, clpuserID: number, parentContactID: number, newContactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/SendThankYouEmail/${clpuserID}/${parentContactID}/${newContactID}`, iHReferralRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, iHReferralRequest, "r - " + encryptedUser, "EngagePostService", "sendThankYouEmail"); });
        return a;
    }

    async getLocationByClass5CodeReferral(encryptedUser: string, class5Code: number, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/GetLocationByClass5CodeReferral/${class5Code}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "getLocationByClass5CodeReferral"); });
        return a;
    }

    async gSyncCodeReferral(encryptedUser: string, clpuserID: number, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/GSyncCodeReferral/${clpuserID}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "gSyncCodeReferral"); });
        return a;
    }

    async addToReferralSubmittedCampaign(encryptedUser: string, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/AddToReferralSubmittedCampaign/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "addToReferralSubmittedCampaign"); });
        return a;
    }

    async tempContactLoadByLinkCode(encryptedUser: string, linkCode: string): Promise<TempContactResponse | void> {
        const a = await this.httpClient
            .get<TempContactResponse>(`${this.baseUrl}/TempContact_LoadByLinkCode/${linkCode}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "tempContactLoadByLinkCode"); });
        return a;
    }

    async tempContactLoad(encryptedUser: string, tempContactID: number): Promise<TempContactResponse | void> {
        const a = await this.httpClient
            .get<TempContactResponse>(`${this.baseUrl}/TempContact_Load/${tempContactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "tempContactLoad"); });
        return a;
    }

    async tempContactUpdate(encryptedUser: string, tempContact: TempContact): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/TempContact_Update`, tempContact, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, tempContact, "r - " + encryptedUser, "EngagePostService", "tempContactUpdate"); });
        return a;
    }

    async engageUnSubscribe(encryptedUser: string, sOEmailUnsubscribeRequest: IHEmailUnsubscribe): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EngageUnSubscribe`, sOEmailUnsubscribeRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, sOEmailUnsubscribeRequest, "r - " + encryptedUser, "EngagePostService", "engageUnSubscribe"); });
        return a;
    }

    async engageUnSubnUnConvertCodeToID(encryptedUser: string, strContactIDCode: string, blnSuppressErrorEmail: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/EngageUnSubnUnConvertCodeToID/${strContactIDCode}/${blnSuppressErrorEmail}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, null, "r - " + encryptedUser, "EngagePostService", "engageUnSubnUnConvertCodeToID"); });
        return a;
    }

    async engageUnSubnSave(encryptedUser: string, EngageUnSubsSaveRequest: EngageUnSubsSaveRequest): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EngageUnSubnSave`, EngageUnSubsSaveRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, EngageUnSubsSaveRequest, "r - " + encryptedUser, "EngagePostService", "engageUnSubnSave"); });
        return a;
    }

    async updateSave(encryptedUser: string, sOUpdateSaveRequest: EngageUpdateSaveRequest, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/UpdateSave?contactID=${contactID}`, sOUpdateSaveRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, sOUpdateSaveRequest, "r - " + encryptedUser, "EngagePostService", "updateSave"); });
        return a;
    }

    async validateTestEval(encryptedUser: string, txtEmail: string): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/ValidateTestEval/${txtEmail}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, "EngagePostService", "validateTestEval"); });
        return a;
    }

    async engageUnSubSave(encryptedUser: string, sOEmailUnsubscribe: EngageEmailUnsubscribe): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EngageUnSubSave`, sOEmailUnsubscribe, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, sOEmailUnsubscribe, "r - " + encryptedUser, "EngagePostService", "engageUnSubSave"); });
        return a;
    }

    async pHFixString(encryptedUser: string, strPHToFix: SimpleDataType): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/PH_FixString`, strPHToFix, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, strPHToFix, "r - " + encryptedUser, "EngagePostService", "pHFixString"); });
        return a;
    }

    async signUp(clpUserId): Promise<APIMessage | void> {
        const a = await this.httpClient
            .post<APIMessage>(`${this.baseUrl}/Signup?cpu=${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "SignupMsg", "", "EngagePostService", "signUp"); });
        return a;
    }

    async setSubStatus(encryptedUser: string, contactID: number, email: string, eInfoStatus: number, ePromoStatus: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/SetSubStatus/?ContactID=${contactID}&Email=${email}&eInfoStatus=${eInfoStatus}&ePromoStatus=${ePromoStatus}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "contactID - " + contactID + " , " + "email - " + email + " , " + "eInfoStatus - " + eInfoStatus + " , " + "ePromoStatus - " + ePromoStatus, encryptedUser, "EngagePostService", "setSubStatus") });
        return a;
    }

    async engageUnSubSetup(strContactIDCode: string = "", contactID: number = 0): Promise<EngageUnSubSetupResponse | void> {
        const a = await this.httpClient
            .get<EngageUnSubSetupResponse>(`${this.baseUrl}/EngageUnSubSetup?strContactIDCode=${strContactIDCode}&contactID=${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, null, "contactID:" + contactID, "EngagePostService", "engageUnSubSetup"); });
        return a;
    }

    async setupEmailPrefConfirm(clpUserId: number = 0): Promise<EmailPrefConfirm | void> {
        const a = await this.httpClient
            .get<EmailPrefConfirm>(`${this.baseUrl}/SetupEmailPrefConfirm/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, null, "clpUserId: " + clpUserId, "SoPostService", "setupEmailPrefConfirm"); });
        return a;
    }
}
